<template>
  <div>
    <Form
      ref="form"
      class="RealisationDetail PageWrapper DetailGrid"
      @error="handleValidationError"
      @submit="handleSubmit"
    >
      <RealisationHeader
        :record="record"
        :feedback="feedback"
        :feedback-message="feedbackMessage"
        :step="currentStep"
        :record-step="step"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            v-if="step !== currentStep"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleCancelChange"
          >
            Annuleren
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleSubmitAndNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else-if="mayEdit">
          <!-- <b-button v-if="openForChange" variant="outline-light" class="ml-3" size="sm" type="submit" :disabled="disabled"
            @click.prevent.stop="handleStartChange">
            Wijzigen
          </b-button> -->
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || step <= currentStep"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>
      </RealisationHeader>

      <RealisationSidebar
        :uuid="uuid"
        :disabled="disabled || locked"
      />

      <template v-if="!reloading">
        <div class="DetailGrid__map">
          <b-alert
            variant="warning"
            :show="!locked && advice === 'alternative'"
          >
            Stel onder aan deze pagina een alternatieve locatie voor.
          </b-alert>
        </div>

        <div class="DetailGrid__col1">
          <CPOAdvice
            :values="values"
            :disabled="locked || disabled"
            @advice="handleAdviceChange"
          />
        </div>
        <div class="DetailGrid__col2">
          <MapLocationViewer
            :record="record"
            :values="values"
          />

          <p>Handmatig startdocument</p>
          <FilesManager
            :uuid="uuid"
            :disabled="true"
            :locked="true"
            :wide="true"
            category="parkingspots"
            view="list"
            linklabel="download"
          />
          <p
            v-if="(values && values.Docs ? values.Docs.ParkingSpots: []).length === 0"
            class="text-muted"
          >
            Er is geen handmatig ingevuld startdocument beschikbaar.
          </p>
          <template v-if="(values && values.Docs ? values.Docs.ParkingSpots : []).length === 0">
            <DocDownload
              class="mb-3"
              :uuid="uuid"
            />
          </template>

          <!-- <strong class="d-block pt-3">Pin coordinaten</strong>
          <Address
            :record="record"
            :values="alternative"
            :viewer="true" /> -->
        </div>

        <div class="DetailGrid__wide">
          <div v-if="advice === 'alternative'">
            <h3>Alternatief locatievoorstel</h3>
            <MapPreSelectedLocationSelection
              v-if="isGORALTenant"
              :record="record"
              :values="alternative"
              :locked="locked"
              :disabled="disabled"
              :alternative="true"
              :connect="true"
            />
            <MapDisconnectedLocationSelection
              v-else
              :record="record"
              :values="alternative"
              :locked="locked"
              :disabled="disabled"
            />
          </div>
        </div>

        <div
          v-if="advice === 'alternative'"
          class="DetailGrid__col3"
        >
          <p>Boven aanzicht</p>
          <FilesManager
            :uuid="uuid"
            :disabled="disabled"
            :locked="locked"
            :wide="true"
            category="topview-alt"
            view="thumbnails"
            linklabel="download"
          />
          <!-- <p
            v-if="(locked || disabled) && (alternative && alternative.Docs ? alternative.Docs.TopView : []).length === 0"
            class="text-muted"
          >
            Er is geen boven aanzicht beschikbaar
          </p> -->
        </div>
        <div
          v-if="advice === 'alternative'"
          class="DetailGrid__col4"
        >
          <p>Zij aanzicht</p>
          <FilesManager
            :uuid="uuid"
            :disabled="disabled"
            :locked="locked"
            :wide="true"
            category="sideview-alt"
            view="thumbnails"
            linklabel="download"
          />
          <!-- <p
            v-if="(locked || disabled) && (alternative && alternative.Docs ? alternative.Docs.SideView : []).length === 0"
            class="text-muted"
          >
            Er is geen zij aanzicht beschikbaar
          </p> -->
        </div>

        <div
          v-if="advice === 'alternative'"
          class="DetailGrid__col5"
        >
          <StepOneMiscBottom
            :values="alternative"
            :disabled="locked || disabled"
          />
        </div>

        <div
          v-if="advice === 'alternative'"
          class="DetailGrid__col6"
        >
          <ChargingSituation
            :values="alternative"
            :disabled="locked || disabled"
          />
        </div>
      </template>

      <RealisationFooter
        :feedback="feedback"
        :feedback-message="feedbackMessage"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            v-if="step !== currentStep"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleCancelChange"
          >
            Annuleren
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleSubmitAndNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else-if="mayEdit">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartCorrection"
          >
            Corrigeren
          </b-button>
          <b-button
            v-if="openForChange"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartChange"
          >
            Wijzigen
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || step <= currentStep"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>
      </RealisationFooter>
    </Form>
    <Comments :uuid="uuid" :version="version" @sync="handleSync" />
  </div>
</template>

<script>

import RealisationHeader from '@/components/realisation/RealisationHeader'
import RealisationFooter from '@/components/realisation/RealisationFooter'
import RealisationSidebar from '@/components/realisation/RealisationSidebar'

import MapDisconnectedLocationSelection from '@/components/map/MapDisconnectedLocationSelection'
import MapPreSelectedLocationSelection from '@/components/map/MapPreSelectedLocationSelection.vue'

import ChargingSituation from '@/components/definitions/ChargingSituation'
import StepOneMiscBottom from '@/components/definitions/StepOneMiscBottom'

import MapLocationViewer from '@/components/map/MapLocationViewer.vue'
// import Address from '@/components/definitions/Address.vue'

import Form from '@/components/form/Form'
import CPOAdvice from '@/components/definitions/CPOAdvice'
// import FileUpload from '@/components/FileUpload.vue'
import DocDownload from '@/components/realisation/DocDownload.vue'

import FilesManager from '@/components/files/FilesManager.vue'

import Comments from '@/components/Comments'

import BaseRealisationStep from '@/views/BaseRealisationStep'

// import Location from '@/models/Location'

import { mapGetters } from 'vuex'

export default {
  name: 'RealisationStep3',
  components: {
    RealisationSidebar, RealisationHeader, RealisationFooter,
    Form, CPOAdvice, 
    // FileUpload,
    MapDisconnectedLocationSelection, MapPreSelectedLocationSelection,
    ChargingSituation, StepOneMiscBottom,
    Comments, MapLocationViewer,
    // Address,
    DocDownload,
    FilesManager,
  },
  mixins: [BaseRealisationStep],
  data() {
    return {
      currentStep: '2',
      advice: null,
    }
  },
  computed: {
    ...mapGetters('tenant', [
      'isCurrentTenant',
    ]),
    /**
     * Load or generate the alternative location
     */
    alternative() {
      try {
        let Alternative = this.values.CPOAdvice.Alternative || this.values.Alternative

        console.log(
          "ALTERNATIVE",
          this.values,
          Alternative
        )

        if (Alternative) {
          // if (Alternative?.ParkingSpots?.Identifiers && Array.isArray(Alternative.ParkingSpots.Identifiers)) {
          //   Alternative.ParkingSpots.Identifiers = Alternative.ParkingSpots.Identifiers.map(id => {
          //     return { Identifier: id }
          //   })
          //   .filter(id => !!id) || []
          // }
          
          return Alternative
        } else {
          throw Error('not a valid location')
        }


        // if (Alternative) {
        //   return new Location({ data: Alternative })
        // } else {
        //   throw Error('not a valid location')
        // }
      } catch (e) {
        // console.log("not a valid location")
        // Copy of step 1 data
        return this.record.values.Location.LocationCopy({ version: this.record.nextLocationVersion() })
      }
    },

    confirmed() {
      try {
        return !! this.values.CPOAdvice.Confirmed
      } catch (e) {
        return false
      }
    },

    minTopViewDocsId() {
      try {
        let Max = this.minIdByDocType({ doctype: 'TopView' })
        let MaxAlt = this.minIdByDocType({ doctype: 'TopView-alt' })
        return Math.max(Max, MaxAlt)
      } catch (e) {
        return 0
      }
    },
    minSideViewDocsId() {
      try {
        let Max = this.minIdByDocType({ doctype: 'SideView' })
        let MaxAlt = this.minIdByDocType({ doctype: 'SideView-alt' })
        return Math.max(Max, MaxAlt)
      } catch (e) {
        return 0
      }
    },
    isGORALTenant() {
      return this.isCurrentTenant({ tenant: 'go-ral' })
    },
  },
  watch: {
    reloading() {
      this.loadAdvice()
    },
    hasRecord() {
      this.loadAdvice()
    },
  },
  created() {
    if (this.hasRecord) {
      this.loadAdvice()
    }
  },
  methods: {

    loadAdvice() {
      try {
        this.advice = this.values.CPOAdvice.CPOAdvice
      } catch (e) {
        // Expected to fail on the first run
      }
    },

    handleAdviceChange({ value }) {
      this.advice = value
    },

    prepData({ data }) {
      let preppedData = {}

      preppedData.Advice = {
        Advice: data.CPOAdvice.CPOAdvice || '', 
        Comments: data.CPOAdvice.CPOComments || ''
      }

      // Try to redirect to step 4 if the advice is positive
      // TODO: CBAPI - DEFERRED - handled by API or intent.target ?
      if (data.CPOAdvice.CPOAdvice === 'yes') {
        this.redirectToAfterSubmit = 4
      }

      // Avoid 400 error
      if (! this.goingToNextStep) {
        if (preppedData.Advice.Advice === '') {
          delete preppedData.Advice.Advice
        }
      }

      // Unless we're suggesting an alternative, we only need the above 2 fields
      if (data.CPOAdvice.CPOAdvice !== 'alternative') {
        return preppedData
      }

      
      preppedData.Alternative = {
        Remarks: data.Remarks || '',
        ParkingSpots: {
          Type: data.ParkingSpots?.Type || 'station',
          NumberOfChargingStations: data.ParkingSpots?.NumberOfChargingStations,
          NumberOfParkingSpots: data.ParkingSpots?.NumberOfParkingSpots,
          Identifiers: (data.ParkingSpots?.Identifiers|| []).map(obj => obj.Identifier).filter(id => !!id)
        }
      }

      // Convert ParkingSpot Identifiers
      // if (data.ParkingSpots) {
      //   preppedData.ParkingSpots = {}
      //   preppedData.ParkingSpots.Identifiers = data.ParkingSpots.Identifiers || []
      //   preppedData.ParkingSpots.Identifiers = preppedData.ParkingSpots.Identifiers.map(obj => obj.Identifier).filter(id => !!id)
      // }

      return preppedData
    },
    /**
     * NOTE! Due to a change in the specs, the municipality was locked out of being able to edit anything in this step
     */
    isValidData({ data }) {
      if (this.goingToNextStep) {
        try {
          if (! ['yes', 'no', 'alternative', 'alternative-without'].includes(data.Advice.Advice)) {
            throw new Error()
          }
        } catch (e) {
          this.disabled = false
          this.feedback = 'danger'
          this.feedbackMessage = 'Het proces kan niet verder zonder beoordeling.'
          return false
        }

        try {
          if (data.Advice.Advice !== 'yes' && (! data.Advice.Comments || data.Advice.Comments.trim() === '')) {
            throw new Error()
          }
        } catch (e) {
          this.disabled = false
          this.feedback = 'danger'
          this.feedbackMessage = 'Het proces kan bij een afwijzing of alternatief niet verder zonder toelichting.'
          return false
        }
      }

      // this.disabled = false
      return true
    },
  },
}
</script>
